import { render, staticRenderFns } from "./account - 副本.vue?vue&type=template&id=1d0a50b7&scoped=true&"
import script from "./account - 副本.vue?vue&type=script&lang=js&"
export * from "./account - 副本.vue?vue&type=script&lang=js&"
import style0 from "./account - 副本.vue?vue&type=style&index=0&id=1d0a50b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a50b7",
  null
  
)

export default component.exports